import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { CheckCircleOutline, ErrorOutline, Close } from "@mui/icons-material";

/**
 * status: one of 'syncing', 'success', 'error'
 * message: string to display for success or error
 * onClose: callback when dialog is closed (for success/error)
 */
export default function SyncingDialog({
  open,
  status = "syncing",
  message = "",
  onClose,
}) {
  // Determine title and content based on status
  let title;
  let content;

  if (status === "syncing") {
    title = "Syncing Files";
    content = (
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 2 }}>
        <CircularProgress size={24} />
        <Typography>Syncing your documents, please wait…</Typography>
      </Box>
    );
  } else if (status === "success") {
    title = "Sync Complete";
    content = (
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 2 }}>
        <CheckCircleOutline fontSize="large" color="success" />
        <Typography>
          {message || "All files have been synced successfully."}
        </Typography>
      </Box>
    );
  } else if (status === "error") {
    title = "Sync Error";
    content = (
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 2 }}>
        <ErrorOutline fontSize="large" color="error" />
        <Typography>
          {message || "There was an error during syncing."}
        </Typography>
      </Box>
    );
  }

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {title}
        {(status === "success" || status === "error") && (
          <IconButton size="small" onClick={onClose}>
            <Close />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
    </Dialog>
  );
}
